/* eslint-disable no-warning-comments */
// @ts-check
/** @typedef {import('@/components/Image').Image} ImageProps */

import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import * as React from 'react'

import Image from '@/components/Image'

gsap.registerPlugin(ScrollTrigger)

/**
 *
 * @param {Object} props
 * @param {Object[]} [props.images]
 * @param {ImageProps} [props.imageProps]
 * @param {string} [props.className]
 * @returns {JSX.Element | null}
 */
const Images = ({images = [], imageProps = {}, className}) => {
  const sectionRef = React.useRef()

  React.useEffect(() => {
    if (sectionRef.current) {
      const context = gsap.context(() => {
        const images = gsap.utils.toArray('img')
        images.forEach((image, index) => {
          const yPercent = gsap.utils.wrap([5, -3, 10], index)
          if (yPercent) {
            gsap.to(image, {
              yPercent,
              ease: 'linear',
              scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top center',
                end: 'bottom 20%',
                scrub: 2,
              },
            })
          }
        })
      }, sectionRef.current)

      return () => context.revert()
    }
  }, [])

  if (images.length > 0) {
    return (
      <div ref={sectionRef} className={className}>
        {images.map((image, index) => (
          <Image key={index} {...image} {...imageProps} />
        ))}
      </div>
    )
  }

  return null
}

export default Images
